export default __webpack_public_path__ + "static/media/330_business03-fr-mobile.502d836c.png";